var _style, _g, _g2, _defs, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConflict = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:#BA16AA;}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.5,
    cy: 27.5,
    r: 26.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,3.2c13.4,0,24.3,10.9,24.3,24.3S40.9,51.8,27.5,51.8S3.2,40.9,3.2,27.5S14.1,3.2,27.5,3.2 M27.5,1.2 C13,1.2,1.2,13,1.2,27.5S13,53.8,27.5,53.8S53.8,42,53.8,27.5S42,1.2,27.5,1.2L27.5,1.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 13.4,
    y: 15.3,
    width: 28.1,
    height: 22.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.7,32.1c0.9,1.5,1.6,3,2.4,4.5c-3.3,1.8-5.6,1.1-9-0.3c-0.4-0.2-0.6-0.6-0.6-1c0.6-3.8,1.2-6.2,4.2-8.1 C18.7,28.8,19.8,30.4,20.7,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.5,27.4c0,0.3-0.2,0.6-0.5,0.7l-4.6,2.7c-0.3,0.2-0.7,0.2-1,0l-3-2.2L32,30.8c0,0.3-0.2,0.5-0.5,0.7 l-6.9,4.1c-0.8-1.5-1.5-3.1-2.4-4.5c-1-1.7-1.9-3.4-3-5l7-4.2c0.2-0.1,0.5-0.1,0.8,0l2,0.9l-0.3-3.8c0-0.4,0.2-0.7,0.5-0.9 l4.6-2.7c0.3-0.1,0.4-0.2,0.5-0.2c0.5-0.1,1,0.3,1,0.8l0.6,5.6L37,21c0.4-0.2,1-0.1,1.3,0.4c0.2,0.4,0.1,1-0.3,1.3l-1.2,0.6 l4.3,3.4C41.4,26.8,41.6,27.1,41.5,27.4z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConflict);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/conflict.03eee672fb381eba48d569b91043e6a9.svg";